"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.noop = function () { return null; };
//# sourceMappingURL=utils.js.map